/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import React, { useState, useCallback } from 'react'
import { Button, Divider, Switch, Input } from 'antd'
import { Filler } from '../screen-util'
import { uniq, none } from 'ramda'

import { filterMultiSelectItem } from 'core/utils'

const MultiSelectPane = ({
  setSelectedIds,
  selectedIds,
  data,
  renderContent,
  toId,
  acceptFilter,
  renderFilters,
}) => {
  const [fuzzyFilter, setFuzzyFilter] = useState(null)
  const [showAll, setShowAll] = useState(true)
  const toggleId = useCallback(
    id =>
      setSelectedIds((ids = []) => (ids.includes(id) ? ids.filter(i => i !== id) : [id, ...ids])),
    [setSelectedIds]
  )
  const filteredData = filterMultiSelectItem({
    data,
    showAll,
    fuzzyFilter,
    acceptFilter,
    selectedIds,
    toId,
  })

  const selectAll = () => setSelectedIds(ids => uniq([...ids, ...filteredData.map(toId)]))
  const deSelectAll = () =>
    setSelectedIds(ids => uniq(ids.filter(id => none(d => id === toId(d), filteredData))))

  return (
    <div>
      <div css={{ display: 'flex', alignItems: 'center' }}>
        <Switch
          checked={showAll}
          onClick={() => setShowAll(a => !a)}
          checkedChildren="All visible"
          unCheckedChildren="Selected visible"
        />
        <Button css={{ marginRight: '10px', marginLeft: '16px' }} onClick={selectAll}>
          Select All
        </Button>
        <Button onClick={deSelectAll}>Clear All</Button>
        <Filler />
        {renderFilters}
        <Input.Search
          placeholder="Filter"
          value={fuzzyFilter}
          onChange={e => setFuzzyFilter(e.target.value)}
          style={{
            marginLeft: '10px',
            flex: '0 0 200px',
          }}
        />
      </div>
      <Divider />
      {renderContent({ data: filteredData, toggleId, selectedIds })}
    </div>
  )
}

export default MultiSelectPane
